import { useCallback } from 'react';
import { useDocumentEditing } from 'contexts/DocumentEditingContext';
import type { DocumentContext, DocumentMode } from 'types/documentEditing';
import type { FileResponse } from 'types/documentStorage';
import { getDocumentActions } from 'utils/documentEditing/documentEditing';
import { isMobileApp } from 'utils/common';

export const useDocumentLaunch = () => {
  const { openDocument } = useDocumentEditing();

  return useCallback(
    (file: FileResponse, mode: DocumentMode, context: DocumentContext): boolean => {
      if (isMobileApp() || !getDocumentActions(file, context).some((action) => action.mode === mode && !action.disabled)) return false;
      return openDocument({ agendaId: context.agendaId, recordId: context.recordId, fileId: file.id, mode }, file.name);
    },
    [openDocument]
  );
};
